import { z } from 'zod'
import { ApiModel } from './core'

const schema = z.object({
  name: z.string(),
})

export type RentalServiceAttributes = z.infer<typeof schema>

export class RentalService extends ApiModel<typeof schema> {
  static jsonApiType = 'rental-services'

  static schema = schema

  getName(): string {
    return this.getAttribute('name')
  }

  getOption(): { id: UniqueId; label: string } {
    return {
      id: this.getApiId() as UniqueId,
      label: this.getName(),
    }
  }

  static async fetchOptions() {
    const response = await RentalService.get(1)
    return response.getData().map((o) => o.getOption())
  }
}
